<template>
  <div class="page-content">
    <div class="box" v-show="showSelectCompany">
      <div class="title" style="display: flex; justify-content: space-between;">
        <p>选择仓库组</p>
        <el-button type="text" @click="logout">退出登录</el-button>
      </div>
      <div class="flex flex-1">
        <div class="system-list">
          <el-tree
            :data="treeData"
            ref="tree"
            node-key="id"
            class="system-tree"
            :default-expand-all="true"
            :expand-on-click-node="false"
            :props="{
              children: 'children',
              label: 'name',
            }"
            highlight-current
            @node-click="handleChangeSystemList"
          >
          </el-tree>
        </div>
        <div class="menu-list flex-1">
          <div v-for="item in listMenuHouseGroup" :key="item.id">
            <p class="p-title">{{ item.name }}</p>
            <div style="display: flex;flex-wrap: wrap;">
              <div
                class="system-item"
                v-for="listItem in item.list"
                :key="listItem.id"
                @click="handleChooseMenu(listItem)"
              >
                {{ listItem.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@common/utils/index.js";
import Cookie from "@/utils/cookie"; // 验权
export default {
  name: "select",
  data() {
    return {
      /**
       * 只有一家公司
       */
      isOnlyOneCompany: false,
      /**
       * 显示公司选择器
       */
      showSelectCompany: false,
      listCompaniesOfIJoined: [],
      activeCompany: "",
      treeData: [],
      listMenuHouseGroup: [],
    };
  },
  created() {
    this.handleSelectSystem();
  },
  methods: {
    logout() {
      this.$store.dispatch("user/fedLogOut").then((res) => {
        window.location.replace(
          `${window.baseConfig.loginServeUrl}/Signout?&redirectUrl=${window.location.href}`
        );
      });
    },
    // 拿企业
    async handleSelectSystem() {
      let res = await this.$api.user.listCompaniesOfIJoined(null, null, 1);
      if (res.success) {
        if (res.data.length === 1) {
          this.isOnlyOneCompany = true;
        }
        this.treeData = utils.companyDataToCompanyTree(res.data);
        if (this.treeData.length > 0) {
          this.activeCompany = this.treeData[0].id;
          this.handleGetListMenuHouseGroup(this.activeCompany);
          this.$nextTick(() => {
            this.$refs["tree"].setCurrentKey(this.activeCompany);
          });
        }
      }
    },
    // 切换仓库组
    handleGetListMenuHouseGroup(id) {
      this.$api.menu
        .listMenuHouseGroup(id, window.baseConfig.subsystemName)
        .then((res) => {
          if (res.success) {
            let apiArr = [];
            let data = res.data;
            // 仓库总数
            let warehouseTotal = 0;
            // 第一个仓库
            let firstWarehouse = null;
            // this.listMenuHouseGroup = data
            for (let i = 0; i < data.length; i++) {
              apiArr.push(this.$api.menu.listMenuHouse(data[i].id));
            }
            Promise.all(apiArr).then((arrRes) => {
              for (let i = 0; i < arrRes.length; i++) {
                if (arrRes[i].success) {
                  if (arrRes[i].data.length > 0 && warehouseTotal === 0) {
                    firstWarehouse = arrRes[i].data[0];
                  }
                  warehouseTotal += arrRes[i].data.length;
                  data[i].list = arrRes[i].data;
                }
              }

              // 如果只有一个公司和一个仓库的情况。直接跳转
              if (this.isOnlyOneCompany && warehouseTotal === 1) {
                this.handleChooseMenu(firstWarehouse);
                return;
              }

              this.listMenuHouseGroup = data;
              this.showSelectCompany = true;
            });
          }
        });
    },
    // 切换企业
    handleChangeSystemList(node, data) {
      this.activeCompany = node.id;
      this.handleGetListMenuHouseGroup(node.id);
    },
    // 选菜单登录 this.$store.commit('user/SET_menuGroup', res.data)
    handleChooseMenu(obj) {
      this.$api.login
        .bindCompanyOfCurrentSession(this.activeCompany)
        .then((res) => {
          if (res.success) {
            Cookie.setCookie("companyId", this.activeCompany);
            Cookie.setCookie("token_houseId", obj.id);
            this.$router.push("/");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
  align-items: center;
  justify-content: center;
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
  overflow: auto;
}
.page-content {
  .box {
    width: 800px;
    height: 600px;
    display: flex;
    flex-flow: column;
    border: 1px solid #dddddd;
    .title {
      flex: 0 0 40px;
      line-height: 40px;
      font-weight: bolder;
      text-align: left;
      padding: 0px 10px;
      border-bottom: 1px solid #dddddd;
    }
    .p-title {
      text-align: left;
      height: 42px;
      line-height: 42px;
    }
  }
  p {
    margin: 0;
  }
  display: flex;
  .system-list {
    box-sizing: border-box;
    width: 200px;
    flex: 0 0 200px;
  }
  .menu-list {
    width: calc(100% - 200px);
    box-sizing: border-box;
    border-left: 1px solid #ddd;
    padding: 0 20px;
    .system-list {
      margin-bottom: 20px;
      .title {
        margin-bottom: 12px;
        text-align: left;
        font-size: 14px;
        font-family: "PingFangSC-Regular, PingFang SC";
        font-weight: 400;
        color: #0080ff;
        line-height: 20px;
      }
    }
    .system-item {
      margin: 0 12px 12px 0;
      width: 140px;
      height: 80px;
      line-height: 80px;
      border-radius: 4px;
      text-align: center;
      border: 1px solid #dddddd;
      color: #333333;
      &:hover {
        background: #e6f7ff;
        border-radius: 4px;
        border: 1px solid #017fff;
      }
    }
  }
}

::v-deep .el-tree-node__content {
  height: 42px;
  &:hover {
    background: #e6f7ff !important;
    color: #333 !important;
  }
}

::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: #e6f7ff;
  border-right: 3px solid #0080ff;
}
</style>
